import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { AlertService, PartnerListService } from '../_services';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { JioMeetingsService } from '../_services/jio-meetings.service';

declare const $:any;

@Component({
  selector: 'app-jio-meetings',
  templateUrl: './jio-meetings.component.html',
  styleUrls: []
})
export class JioMeetingsComponent implements OnInit {

  dtOptions: DataTables.Settings = {}; 
  dtTrigger = new Subject(); 
  jioMeetList: any[] = []; 
  closeResult: string; 
  menteeName:any
  mentorName:any
  dynamicRating:any
  dynamic_rating:any
  feedBackList:any=[]
  constructor(
              public router: Router,
              private dataService:JioMeetingsService,
              private alertService: AlertService,
              private modalService: NgbModal
            ) { }
    
  menteeFeedBack = {
    "created_at" : '',
    "created_by" : '',
    "feedback" : '',
    "feedback_by" : '',
    "feedback_by_id" : '',
    "id" : '',
    "meeting_id" :'',
    "rating" :''
  }

  mentorFeedBack = {
    "created_at" : '',
    "created_by" : '',
    "feedback" : '',
    "feedback_by" : '',
    "feedback_by_id" : '',
    "id" : '',
    "meeting_id" :'',
    "rating" :''
  }
          
  modalReference:NgbActiveModal;
  modalTitle:string;
  showloding = true;
  lodingImage = false;

  ngOnInit() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.jiomeetList();
    
  }

jiomeetList(){
    this.loadShow();
    this.dataService.getJiomeetList().pipe().subscribe(res => { 
       if(res.status == 200){
        this.jioMeetList = res['data']
      
        console.log( this.jioMeetList,"res");
        this.dtTrigger.next();        
       }     
         this.loadHide(); 
       });
    }


openFeedbackModel(slug,item,content){  
  const modalOptions: NgbModalOptions = {
    backdrop: 'static', 
    keyboard: false,   
  };
  this.menteeName = item.mentee_name
  this.mentorName =  item.mentor_name
  console.log( item,"item");

    this.loadShow();
    const data = {
     "slug" : slug
    }
    this.dataService.getFeedbackList(data).subscribe((res:any) => { 
      // console.log(res,"res feed");
       if(res.status == 200){
        this.feedBackList = res['data']['feedback']
        console.log(this.feedBackList,"feedBackList");
        
        this.feedBackList.filter((feed:any)=>{
         if(feed.feedback_by == 'MENTOR'){

           this.mentorFeedBack = feed
           this.dynamicRating = this.mentorFeedBack.rating
           this.getMentorStars(this.dynamicRating)
             
          }else{
            this.menteeFeedBack =  feed
            this.dynamic_rating = this.menteeFeedBack.rating
            this.getMenteeStars(this.dynamic_rating)
          }
        })
       }     
         this.loadHide(); 
         this.modalTitle = "JioMeeting Feedback"; 
         this.modalReference = this.modalService.open(content,modalOptions);
       });
    }

    onCloseButtonClick(){
      this.getMentorStars(0)
      this.getMenteeStars(0)
      this.modalService.dismissAll('Cross click');  
    }

    getMentorStars(rating: any): any[] {
      return Array.from({ length: rating }, (_, index) => index + 1);
    }

    getMenteeStars(rating: any): any[] {
      return Array.from({ length: rating }, (_, index) => index + 1);
    }

  openJioMeetViewPage(slug) {
    this.router.navigate(['jio-meet-view/' + slug]);
   }

  loadShow(){
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide(){
    this.showloding = false;
    this.lodingImage = true;
  }

}
